export default "__VITE_ASSET__CTN7$kCa__"